"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupSentryAction = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var Sentry = tslib_1.__importStar(require("@sentry/browser"));
var tracing_1 = require("@sentry/tracing");
var inversify_1 = require("inversify");
var SetupSentryAction = (function (_super) {
    tslib_1.__extends(SetupSentryAction, _super);
    function SetupSentryAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetupSentryAction.prototype.execute = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                config = this.getConfig();
                if (config) {
                    Sentry.init(tslib_1.__assign(tslib_1.__assign({}, config), { integrations: [new tracing_1.Integrations.BrowserTracing()], tracesSampleRate: 1.0 }));
                    Sentry.configureScope(function (scope) {
                        var normalizeUrl = function (url) {
                            return url.replace(/^(.*:)\/\/([A-z0-9\-.]+)(:[0-9]+)?\/(.*)\//, "~/".concat(config.project, "-").concat(__SOCIAL__, "/").concat(config.release, "/"));
                        };
                        scope.addEventProcessor(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a, _b, _c;
                            return tslib_1.__generator(this, function (_d) {
                                if (event.culprit) {
                                    event.culprit = normalizeUrl(event.culprit);
                                }
                                if ((_c = (_b = (_a = event.exception) === null || _a === void 0 ? void 0 : _a.values[0]) === null || _b === void 0 ? void 0 : _b.stacktrace) === null || _c === void 0 ? void 0 : _c.frames) {
                                    event.exception.values[0].stacktrace.frames =
                                        event.exception.values[0].stacktrace.frames.map(function (frame) {
                                            frame.filename = normalizeUrl(frame.filename);
                                            return frame;
                                        });
                                }
                                return [2, event];
                            });
                        }); });
                    });
                }
                return [2];
            });
        });
    };
    SetupSentryAction.prototype.getConfig = function () {
        var origConfig = this.gameConfig.sentry;
        if (origConfig) {
            origConfig.environment = [__SOCIAL__, process.env.NODE_ENV].filter(function (c) { return !!c; }).join("-");
        }
        return origConfig;
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesCore.gameConfig),
        tslib_1.__metadata("design:type", Object)
    ], SetupSentryAction.prototype, "gameConfig", void 0);
    SetupSentryAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], SetupSentryAction);
    return SetupSentryAction;
}(core_1.Action));
exports.SetupSentryAction = SetupSentryAction;
//# sourceMappingURL=SetupSentryAction.js.map